import styled from "styled-components";
import theme from "../../utils/theme";

/**
 * @brief 페이지 section 스타일드 컴포넌트
 * @remark 백그라운드 기본 - none
 * @params backgroundColor
 */
function MainSection({ backgroundColor, disableSidePadding, children }) {
  return (
    <SContainer backgroundColor={backgroundColor}>
      <SBox disableSidePadding={disableSidePadding}>{children}</SBox>
    </SContainer>
  );
}

export default MainSection;

export const SContainer = styled.section`
  width: 100%;
  max-width: 430px;
  margin: 0 auto;
  background: ${({ backgroundColor }) => backgroundColor ?? "none"};
`;

export const SBox = styled.article`
  display: flex;
  max-width: ${theme.defaultMaxWidth};
  padding: 50px
    ${({ disableSidePadding }) =>
    !disableSidePadding ? theme.defaultMobilePadding : "0px"};
  margin: 0 auto;
  flex-direction: column;
`;
